import React from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";

import Helper from "../../../../Utils/Helper";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";

import { BreathAPIs } from "../../../../APIs/BreathAPIs";
import { ButtonCustom } from "../../../../BootstrapComponents/ButtonCustom";
import styles from "../style.module.css";

const RateBreakDownAutoReload = ({
  userGroups,
  userAvgPower,
  usersFreeChargingLocations,
  setIsSubmitting,
  isSubmitting,
  locationData,
  selectedConnectorForAutopay,
  timeFormatAmPm,
}) => {

    console.log("Status of selected connector for autopay: ", selectedConnectorForAutopay.status);
  const navigate = useNavigate();
  const [
    isFreeChargingForSelectedLocation,
    setIsFreeChargingForSelectedLocation,
  ] = useState(false);
  const [
    isCustomEnergyRateForSelectedLocation,
    setIsCustomEnergyRateForSelectedLocation,
  ] = useState(false);
  const [customEnergyRate, setCustomEnergyRate] = useState(0);
  const [selectedLocation, setSelectedLocation] = useState(locationData._id);
  const [estimateResponse, setEstimateResponse] = useState(null);
  function isFreeChargingAllowedInSelectedLocation(
    locationsFromPermission = [],
  ) {
    if (usersFreeChargingLocations.includes(selectedLocation)) {
      return true;
    }
    if (locationsFromPermission.includes(selectedLocation)) {
      return true;
    }
    // }
    if (
      usersFreeChargingLocations.length === 0 &&
      locationsFromPermission.length === 0
    ) {
      return true;
    }
    return false;
  }

  function isCustomEnergyRateEnabledInSelectedLocation(
    customEnergyRateEnabledLocations = null,
  ) {
    try {
      if (customEnergyRateEnabledLocations) {
        if (customEnergyRateEnabledLocations.length === 0) {
          return true;
        } else {
          if (customEnergyRateEnabledLocations.includes(selectedLocation)) {
            return true;
          } else {
            return false;
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  useEffect(() => {
    setIsFreeChargingForSelectedLocation(false);
    try {
      userGroups.filter((userGroup) => {
        try {
          let parsedPermissions = JSON.parse(userGroup.permissions);

          try {
            if (
              parsedPermissions?.freeCharging &&
              parsedPermissions?.freeCharging === "allowed"
            ) {
              let isFreeCharging;

              if ("freeChargingAllowedLocations" in parsedPermissions) {
                isFreeCharging = isFreeChargingAllowedInSelectedLocation(
                  parsedPermissions.freeChargingAllowedLocations,
                );
              } else {
                isFreeCharging = isFreeChargingAllowedInSelectedLocation();
              }
              isFreeCharging
                ? setIsFreeChargingForSelectedLocation(true)
                : setIsFreeChargingForSelectedLocation(false);
            }
          } catch (error) {
            console.log(error.message);
          }

          try {
            if (
              parsedPermissions?.customEnergyRate &&
              parsedPermissions?.customEnergyRate === "enabled"
            ) {
              let isCustomEnergyRateEnabled = false;
              if ("customEnergyRateEnabledLocations" in parsedPermissions) {
                isCustomEnergyRateEnabled =
                  isCustomEnergyRateEnabledInSelectedLocation(
                    parsedPermissions.customEnergyRateEnabledLocations,
                  );
              } else {
                isCustomEnergyRateEnabled = true;
              }

              if (isCustomEnergyRateEnabled) {
                setIsCustomEnergyRateForSelectedLocation(true);
                setCustomEnergyRate(
                  parsedPermissions?.customEnergyRateEnabledRate,
                );
              } else {
                setIsCustomEnergyRateForSelectedLocation(false);
                setCustomEnergyRate(0);
              }
            }
          } catch (error) {
            console.log(error.message);
          }
        } catch (error) {
          console.log(error.message);
        }
      });
    } catch (error) {
      console.log(error.message);
    }
  }, [selectedLocation]);

  useEffect(() => {
    let time = locationData.maxChargeDuration * 60;
    let startDateTime = new Date();
    let endDateTime = new Date(
      startDateTime.getTime() + locationData.maxChargeDuration * 60 * 60 * 1000,
    );
    let selectedConnector = selectedConnectorForAutopay;
    let onGoingBookingEstimate = Helper.calculateEstimatedAmount(
      time,
      startDateTime,
      endDateTime,
      null,
      true,
      isCustomEnergyRateForSelectedLocation,
      customEnergyRate,
      selectedConnector,
      [],
      [locationData],
      0,
      null,
      userAvgPower,
      false,
    );
    // console.log(
    //   "ongoing estimate in autopay non res: ",
    //   onGoingBookingEstimate,
    // );
    setEstimateResponse(onGoingBookingEstimate);
  }, [selectedConnectorForAutopay, customEnergyRate, selectedLocation]);

  const handleInitiate = async () => {
    try {
      setIsSubmitting(true);
      let response = await BreathAPIs.createAutoPayNonResBooking(
        selectedConnectorForAutopay,
        new Date(),
        locationData.timezone,
      );

      if (response.status === 200) {
        navigate("/bookingHist", { state: { bookingSuccess: true } });
      }

      return;
    } catch (error) {
      console.log(
        "error in creating booking for auto pay users",
        error.message,
      );
      toast.error("something went wrong please try again");
    } finally {
      setIsSubmitting(false);
    }
  };

  function formatRateRangeTime(rangeStart, rangeEnd) {
    const opts = { hour: "numeric", minute: "2-digit", hour12: timeFormatAmPm };
    const startLabel = new Date(rangeStart).toLocaleTimeString("en-US", opts);
    const endLabel = new Date(rangeEnd).toLocaleTimeString("en-US", opts);
    return `${startLabel} - ${endLabel}`;
  }

  function formatDurationFromMinutes(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    let formatted = "";
    if (hours > 0) {
      formatted += `${hours} hour${hours > 1 ? "s" : ""}`;
    }
    if (minutes > 0 || hours === 0) {
      formatted += `${hours > 0 ? ", " : ""}${minutes} minute${minutes !== 1 ? "s" : ""}`;
    }
    return formatted;
  }

  const maxDurationMinutes = Math.round((locationData.maxChargeDuration || 0) * 60);
  const gracePeriodMinutes = maxDurationMinutes >= 30 ? 10 : 5;
  const chargeDurationMinutes = maxDurationMinutes - gracePeriodMinutes;

  const estimateSplit = estimateResponse?.rateSplit;
  const regularRatePerKwh = isCustomEnergyRateForSelectedLocation
    ? parseFloat(customEnergyRate)
    : (selectedConnectorForAutopay ? selectedConnectorForAutopay.rate.price_components.price : 0);

  return (
    <div>
      {!estimateResponse && <div className={styles["info-data"]}>Loading rate breakdown...</div>}
      {estimateResponse && (
        <>
          <div className={styles["info-data"]}>
            <div>Charge Duration: {formatDurationFromMinutes(chargeDurationMinutes)}</div>
          </div>
          {
            ((estimateSplit?.dynamicRates?.length > 0 || estimateSplit?.normalRate > 0 || estimateSplit?.tax > 0) && !isFreeChargingForSelectedLocation) &&
            <div className={styles["info-data"]}>
              <div className={styles.rateSplitTitle}>Rate Breakdown</div>
              {estimateSplit.powerUsed > 0 &&
                <div className={styles.idleFeeDiv}>
                  <span className={styles.rateSplitLabel}>Calculated using {estimateSplit.isUserAvgPowerUsed ? 'your average charging power' : "charger's rated power"}</span>
                  <span className={styles.rateSplitValue}>{estimateSplit.powerUsed?.toFixed(2)} kW</span>
                </div>
              }
              {estimateSplit.dynamicRates.filter((range) => range.estimateInRange > 0).map((range, idx) => (
                <div key={idx} className={styles.idleFeeDiv}>
                  <span className={styles.rateSplitLabel}>{formatRateRangeTime(range.rangeStart, range.rangeEnd)} @ $ {range.perkWhCost?.toFixed(2)}/kWh</span>
                  <span className={styles.rateSplitValue}>$ {range.estimateInRange?.toFixed(2)}</span>
                </div>
              ))}
              {estimateSplit.normalRate > 0 &&
                <div className={styles.idleFeeDiv}>
                  <span className={styles.rateSplitLabel}>Regular Rate ($ {regularRatePerKwh?.toFixed(2)}/kWh)</span>
                  <span className={styles.rateSplitValue}>$ {estimateSplit.normalRate.toFixed(2)}</span>
                </div>
              }
              <div className={styles.idleFeeDiv}>
                <span className={styles.rateSplitLabel}>Tax</span>
                <span className={styles.rateSplitValue}>$ {(estimateSplit.tax || 0).toFixed(2)}</span>
              </div>
            </div>
          }
          <hr></hr>
          <div className={styles["estimated-amount"]}>
            Total estimated Amount : $ {isFreeChargingForSelectedLocation  ? "0.00" : estimateResponse.estimateAmount?.toFixed(2)}
          </div>
        </>
      )}
      <div className="d-grid">
        <ButtonCustom
          isLoading={isSubmitting}
          disabled={isSubmitting || !estimateResponse || selectedConnectorForAutopay.status !== "Preparing"}
          text={isSubmitting ? "Initiating..." : selectedConnectorForAutopay.status === "Preparing" ? "Initiate" : "Plug-in to Vehicle"}
          style={{ width: "100%" }}
          onClick={() => {
            handleInitiate();
          }}
        />
      </div>
    </div>
  );
};

// export default RateBreakDownAutoReload

RateBreakDownAutoReload.propTypes = {
  // user: PropTypes.string,
  // userID: PropTypes.string,
  userGroups: PropTypes.array,
  usersFreeChargingLocations: PropTypes.array,
  // location: PropTypes.array,
  // balance: PropTypes.number,
  // isUserTester: PropTypes.bool,
  // isAutoPayEnabled: PropTypes.bool,
  timeFormatAmPm: PropTypes.bool,
  // isPhoneVerified: PropTypes.bool,
  // phone: PropTypes.string,
  userAvgPower: PropTypes.object,
};
const mapStateToProps = (state) => ({
  // user: state.auth && state.auth.user ? state.auth.user.firstName : null,
  // userID: state.auth && state.auth.user ? state.auth.user._id : null,
  userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
  // location: state.auth && state.auth.user ? state.auth.user.location : null,
  usersFreeChargingLocations:
    state.auth && state.auth.user
      ? state.auth.user.freeChargingAllowedLocations
      : [],
  // balance: state.auth && state.auth.user ? state.auth.user.wallet.coins : null,
  // isUserTester: state.auth && state.auth.user ? state.auth.user.isUserTester : false,
  // isAutoPayEnabled: state.auth && state.auth.user ? state.auth.user.isAutoPayEnabled : false,
  timeFormatAmPm: state.auth && state.auth.user ? state.auth.user.timeFormatAmPm : false,
  // isPhoneVerified: state.auth && state.auth.user ? state.auth.user.isPhoneVerified : false,
  // phone: state.auth && state.auth.user ? state.auth.user.phone : false,
  userAvgPower: state.auth && state.auth.user ? state.auth.user.avgPower : null,
});
export default connect(mapStateToProps, {})(RateBreakDownAutoReload);
